/* Sticky Add-to-Cart — Beck & Bulow
   Vanilla JS, ~1KB, no dependencies. */

(function () {
  'use strict';

  const bar = document.querySelector('[data-bb-sticky-atc]');
  if (!bar) return;

  const threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 600;
  const variantInput = bar.querySelector('[data-bb-sticky-variant]');
  const priceEl = bar.querySelector('[data-bb-sticky-price]');

  // Show only after the user scrolls past threshold
  let visible = false;
  function update() {
    const scrollY = window.scrollY || window.pageYOffset;
    const shouldShow = scrollY > threshold;
    if (shouldShow !== visible) {
      visible = shouldShow;
      if (shouldShow) {
        bar.removeAttribute('hidden');
        // Allow CSS transition to fire on next frame
        requestAnimationFrame(function () {
          bar.classList.add('is-visible');
          document.body.classList.add('has-sticky-atc');
        });
      } else {
        bar.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-atc');
        // Hide after transition
        setTimeout(function () {
          if (!visible) bar.setAttribute('hidden', '');
        }, 250);
      }
    }
  }

  // Throttle scroll events
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Sync variant ID + price when the main product form changes
  // Listen for changes on the main variant selector (radio or select)
  const mainForm = document.querySelector('form[action*="/cart/add"]:not([data-bb-sticky-form])');
  if (mainForm && variantInput) {
    const mainVariantInput = mainForm.querySelector('[name="id"]');
    if (mainVariantInput) {
      // Sync on initial load
      variantInput.value = mainVariantInput.value;

      // Watch for variant changes (Shopify variant scripts update the hidden input)
      const observer = new MutationObserver(function () {
        variantInput.value = mainVariantInput.value;
      });
      observer.observe(mainVariantInput, { attributes: true, attributeFilter: ['value'] });

      // Also listen to form change events as a fallback
      mainForm.addEventListener('change', function () {
        if (mainVariantInput.value) variantInput.value = mainVariantInput.value;
      });
    }
  }

  // Initial check (in case page is already scrolled — e.g. anchor link)
  update();
})();